<template >
  <!-- Open (unlocked) icon -->
 <span :title="isOpen ? 'Open' : 'Closed'">
  <svg
    v-if="isOpen"
    class="lock-icon lock-open"
    viewBox="0 0 24 24"
    role="img"
    aria-hidden="true"
    :style="sizeStyle"
  >
    <rect x="3" y="10" width="18" height="11" rx="2" class="body-fill" />
    <rect x="3" y="10" width="18" height="11" rx="2" class="stroke" />
    <path d="M16 7a4 4 0 0 0-8 0" transform="rotate(-25 12 9)" class="stroke" />
    <circle cx="12" cy="15" r="1.7" class="stroke" />
  </svg>

  <!-- Closed (locked) icon -->
  <svg
    v-else
    class="lock-icon lock-closed"
    viewBox="0 0 24 24"
    role="img"
    aria-hidden="true"
    :style="sizeStyle"
  >
    <rect x="3" y="10" width="18" height="11" rx="2" class="body-fill" />
    <rect x="3" y="10" width="18" height="11" rx="2" class="stroke" />
    <path d="M7 10V7a5 5 0 0 1 10 0v3" class="stroke" />
    <circle cx="12" cy="15" r="1.7" class="stroke" />
  </svg>
 </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  // Accepts 1/'open' for open; anything else treated as closed
  status: { type: [String, Number], required: true },
  size: { type: [String, Number], default: 16 },
})

const isOpen = computed(() => {
  const v = typeof props.status === 'string' ? props.status.toLowerCase() : props.status
  return v === 1 || v === 'open'
})

const sizeStyle = computed(() => ({ width: `${props.size}px`, height: `${props.size}px` }))
</script>

